$(() => {
  if (!$('[data-toggle="popover"]').length) {
    return
  }
  $('[data-toggle="popover"]').popover({
    'html': true,
  })
})
